import { Component, OnInit, Input } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { Iaddress, Users } from 'my-lib-sanfelici';
import { UsersService } from 'my-lib-sanfelici';
import { NewMapsDialogViewComponent } from '../../new-maps/new-maps-dialog-view/new-maps-dialog-view.component';

@Component({
  selector: 'app-delivery-form',
  templateUrl: './delivery-form.component.html',
  styleUrls: ['./delivery-form.component.scss']
})
export class DeliveryFormComponent implements OnInit {
@Input() user: Users;

address: Iaddress;
  constructor(
    public dialog: MatDialog,
    private usersservice: UsersService) { }
  onchange($event) {
    this.usersservice.update(this.user);
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(NewMapsDialogViewComponent, {
data: {address: this.address}
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
      this.address = result;
      this.user.delivery.address = this.address;
      this.usersservice.update(this.user);
      }

      console.log('The dialog was closed');
      console.log(this.address);
    });

  }
  ngOnInit() {
    if (this.user) {
      if (this.user.delivery){

      } else {
        this.user.delivery = {
         nominativo: null
        }
      }
    }
  }

}
